// Ana sayfa "Personel Performansı - Normal Görevler" yığılmış çubuk grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.normalTaskPersonnelPerformance';

export const normalTaskPersonnelPerformanceGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Personel Performansı - Normal Görevler nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu grafik, en aktif 5 personelinizin normal (tek seferlik) görevlerdeki performansını gösterir. Her yatay çubuk bir personelin görev dağılımını temsil eder; personeller toplam görev sayısına göre çoktan aza sıralanır. Çubuk parçalarının içindeki sayılar görev adedidir.'),
  chart: {
    kind: 'stacked',
    legend: [
      { color: '#6A1B9A', label: t(`${G}.l1.label`, 'Tamamlanan'), text: t(`${G}.l1.text`, 'Personelin tamamladığı normal görevlerin sayısı.') },
      { color: '#1976D2', label: t(`${G}.l2.label`, 'Devam Eden'), text: t(`${G}.l2.text`, 'Personelin henüz tamamlamadığı normal görevlerin sayısı: kabul ettiği, başlattığı veya beklemedeki görevler.') },
    ],
    note: t(`${G}.note`, 'Personele atanmamış görevler bu grafikte sayılmaz.'),
  },
});
